import { Box, Typography, Grid } from "@mui/material";
import useTracking from "../hooks/useTracking";


function ContactimageBottom() {

   const { ref, handleClick } = useTracking("ContactimageBottom");



  return (
    <Box

     ref={ref}
      sx={{
        position: "relative",
        backgroundImage: "url('/img1/contactfooter.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        borderRadius: "10px",
        // color: "white",
        display: "flex",
        minHeight: { xs: "auto", md: "auto" },
        px: { xs: 1, sm: 2, md: 8 },
        py: { xs: 1, sm: 2, md: 8 },
       

      }}
    >
      <Grid container>
        {/* LEFT SIDE TEXT */}
        <Grid item xs={6} md={6}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 900,
              color: "#f7ef6d",
              mb: { xs: 1, sm: 2 },
              fontSize: { xs: "15px",sm:"2rem",md: "3rem" },
              textAlign: 'left',
              fontFamily: 'Poppins' 
            }}
          >
           Start Shopping your favorite brands from Dubai
          </Typography>

          <Typography
            variant="body1"
            sx={{
              color: "#f7ef6d",
              mb: { xs: 1, sm: 2 },
              fontSize: { xs: "13px",sm:"1rem", md: "1.4rem" },
              textAlign: 'left'
            }}
          >
           Download App Now !
          </Typography>

          <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", mt: { xs: 5, sm: 5, md: 15 } }}>
            <Box
              component="img"
              src="/img1/Appstorebanner.png"
              alt="App Store"
              sx={{ width: { xs: 65, md: 130 }, cursor: "pointer" }}
               onClick={() => {
                  window.open(
                    "https://apps.apple.com/in/app/yubai/id6751202148",
                    "_blank"
                  );
                  handleClick("appstore_banner_clicked");
                }}
            />
            <Box
              component="img"
              src="/img1/Playstorebanner.png"
              alt="Google Play"
              sx={{ width: { xs:65, md: 130 }, cursor: "pointer", objectFit: 'contain' }}
                 onClick={() => {
                  window.open(
                    "https://play.google.com/store/apps/details?id=com.yubai.app",
                    "_blank"
                  );
                  handleClick("playstore_banner_clicked");
                }}
            />
          </Box>
        </Grid>
      </Grid>
    </Box>

 
  )
}

export default ContactimageBottom